import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./Nav.css";

const Nav: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="nav">
      <div className="nav-inner">
        <a href="/" className="nav-logo">
          <img src="/img/logo.png" alt="Ametros Logo" />
        </a>
        <ul className="nav-links">
          <li>
            <a href="/#services">{t("nav.services")}</a>
          </li>
          <li>
            <a href="/#solutions">{t("nav.solutions")}</a>
          </li>
          <li>
            <a href="/#partners">{t("nav.partners")}</a>
          </li>
          <li>
            <a href="/#contact">{t("nav.contact")}</a>
          </li>
        </ul>
        <div className="nav-right">
          <div className="nav-languages">
            <button
              className={`nav-lang ${i18n.language === "en" ? "active" : ""}`}
              onClick={() => changeLanguage("en")}
            >
              en
            </button>
            <span className="nav-lang-separator">•</span>
            <button
              className={`nav-lang ${i18n.language === "hr" ? "active" : ""}`}
              onClick={() => changeLanguage("hr")}
              disabled
            >
              hr
            </button>
          </div>
          <button
            className={`nav-hamburger ${isMenuOpen ? "open" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`nav-mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <div className="nav-mobile-menu-content">
          <ul className="nav-mobile-links">
            <li>
              <a href="/#services" onClick={closeMenu}>
                {t("nav.services")}
              </a>
            </li>
            <li>
              <a href="/#solutions" onClick={closeMenu}>
                {t("nav.solutions")}
              </a>
            </li>
            <li>
              <a href="/#partners" onClick={closeMenu}>
                {t("nav.partners")}
              </a>
            </li>
            <li>
              <a href="/#contact" onClick={closeMenu}>
                {t("nav.contact")}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
